import { lazy, Suspense } from "react";
import "./App.css";
import Ambient from "./component/Ambient";
import Navbar from "./component/Navbar";
import Hero from "./scenes/Hero";

const Markour = lazy(() => import("./scenes/Markour"));
const Bluelink = lazy(() => import("./scenes/Bluelink"));
const Nextcloud = lazy(() => import("./scenes/Nextcloud"));
const PTS = lazy(() => import("./scenes/PTS"));
const DevCon = lazy(() => import("./scenes/DevCon"));
const AboutSections = lazy(() =>
  import("./scenes/About").then((m) => ({
    default: function AboutSections() {
      return (
        <>
          <m.About />
          <m.Contact />
          <m.Footer />
        </>
      );
    },
  }))
);

function Deferred({ children }) {
  return <Suspense fallback={null}>{children}</Suspense>;
}

export default function App() {
  return (
    <main className="app">
      <Ambient />
      <Navbar />
      <div className="content">
        <Hero />
        <Deferred>
          <Markour />
        </Deferred>
        <Deferred>
          <Bluelink />
        </Deferred>
        <Deferred>
          <Nextcloud />
        </Deferred>
        <Deferred>
          <PTS />
        </Deferred>
        <Deferred>
          <DevCon />
        </Deferred>
        <Deferred>
          <AboutSections />
        </Deferred>
      </div>
    </main>
  );
}
